import Accordion from "@/common/components/Accordion";
import { Control, Controller, FieldErrors, useWatch } from "react-hook-form";
import { UnitTextField } from "@/common/components/UnitTextField";
import SelectController from "@/common/components/SelectController";
import { ErrorMessage } from "@/common/components/ErrorMessage";
import { CreateWorkflowSchedulesSchema } from "../services/workflowSchedules.schema";
import { maintenanceWorkflowSchedulesExecutionOptions } from "../constants/executionOptions.constant";
import { unitStrategy } from "@/common/constants/unitStrategies.contants";

interface AccordionMaintenanceWorkflowSchedulesExecutionProps {
  errors: FieldErrors<CreateWorkflowSchedulesSchema>
  control: Control<CreateWorkflowSchedulesSchema>
  disabled?: boolean
}

export default function AccordionMaintenanceWorkflowSchedulesExecution({ errors, control, disabled }: AccordionMaintenanceWorkflowSchedulesExecutionProps) {
  const executionOptions = useWatch({
    control,
    name: 'execution_options'
  })

  const hasKilometers = executionOptions?.some((option) => option.value === 'kilometers_usage')
  const hasDays = executionOptions?.some((option) => option.value === 'days')
  const hasHours = executionOptions?.some((option) => option.value === 'hours_usage')

  return (
    <Accordion
      name="maintenanceWorkflowSchedulesExecution"
      head={
        <div className="flex w-full flex-col items-start gap-y-1">
          <p>
            Execução da programação de manutenção {!disabled && <span className="text-danger-soft"> *</span>}
          </p>

          {!!errors.execution_options?.message && (
            <ErrorMessage name="execution_options" message={errors.execution_options?.message} />
          )}
        </div>
      }
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="execution_options"
            label="Pesquisar opções para execução da programação (ao menos 1 opção é necessária)"
            className="w-full"
            markAsRequired={!disabled}
            isMulti
            options={maintenanceWorkflowSchedulesExecutionOptions}
            errorMessage={errors.execution_options?.message || undefined}
            isDisabled={disabled}
          />
          
          {hasKilometers && (
            <Controller
              control={control}
              name="interval_in_kilometers_usage"
              render={({ field }) => (
                <UnitTextField
                  {...field}
                  key='kilometers-input'
                  decimals={0}
                  unit={unitStrategy.kilometers}
                  maxValue={99_999_999}
                  label="Quilômetros percorridos"
                  errorMessage={errors?.interval_in_kilometers_usage?.message}
                  disabled={disabled}
                />
              )}
            />
          )}

          {hasDays && (
            <Controller
              control={control}
              name="interval_in_days"
              render={({ field }) => (
                <UnitTextField
                  {...field}
                  key="days-input"
                  decimals={0}
                  unit='Dias'
                  maxValue={99_999_999}
                  label="Dias passados"
                  errorMessage={errors?.interval_in_days?.message}
                  disabled={disabled}
                />
              )}
            />
          )}
          
          {hasHours && (
            <Controller
              control={control}
              name="interval_in_hours_usage"
              render={({ field }) => (
                <UnitTextField
                  {...field}
                  key='hours-input'
                  decimals={0}
                  unit={unitStrategy.hours}
                  maxValue={99_999_999}
                  label="Horas passadas"
                  errorMessage={errors?.interval_in_hours_usage?.message}
                  disabled={disabled}
                />
              )}
            />
          )}
        </div>
      }
    />
  )
}
